export default __webpack_public_path__ + "static/media/path-1.1ad67c87.svg";